import { call, put, takeLatest } from "redux-saga/effects";
import apiClient from "../../api/apiClient";
import {
  createFieldTypeSuccess,
  createFieldTypeFailure,
  createFieldTypeStart,
  updateFieldTypeSuccess,
  updateFieldTypeFailure,
  updateFieldTypeStart,
  deleteFieldTypeSuccess,
  deleteFieldTypeFailure,
  deleteFieldTypeStart,
} from "../../store/features/fieldType/fieldTypeSlice";
import { fetchFieldsTypeStart } from "../../store/features/fieldsType/fieldsTypeSlice";

const path = "/api/v1/field_type/field_type/";

// CREATE
const createFieldTypeApi = async ({ data, accessToken }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.post("/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleCreateFieldTypeSaga(action) {
  try {
    const data = yield call(createFieldTypeApi, action.payload);
    yield put(createFieldTypeSuccess(data));
  } catch (error) {
    yield put(createFieldTypeFailure(error));
  }
}

// UPDATE
const updateFieldTypeApi = async ({ data, accessToken, fieldTypeId }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.put(`${fieldTypeId}/`, data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleUpdateFieldTypeSaga(action) {
  try {
    const data = yield call(updateFieldTypeApi, action.payload);
    yield put(updateFieldTypeSuccess(data));
  } catch (error) {
    yield put(updateFieldTypeFailure(error.message));
  }
}

// DELETE
const deleteFieldTypeApi = async ({ accessToken, fieldTypeId }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.delete(`${fieldTypeId}`);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleDeleteFieldTypeSaga(action) {
  try {
    const data = yield call(deleteFieldTypeApi, action.payload);
    yield put(deleteFieldTypeSuccess(data));
    yield put(
      fetchFieldsTypeStart({ accessToken: action.payload.accessToken })
    );
  } catch (error) {
    yield put(deleteFieldTypeFailure(error.message));
  }
}

export default function* fieldTypeSaga() {
  yield takeLatest(createFieldTypeStart.type, handleCreateFieldTypeSaga);
  yield takeLatest(updateFieldTypeStart.type, handleUpdateFieldTypeSaga);
  yield takeLatest(deleteFieldTypeStart.type, handleDeleteFieldTypeSaga);
}
